import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
interface IRejectModalContext {
  question: string;
  title?: string;
}
@Component({
  selector: 'app-reject-modal',
  template: `
    <h3 id="header" class="ui primary header">
      {{ modal.context.title }}
      <i class="link times icon" (click)="modal.deny(undefined)"></i>
    </h3>
    <div class="ui form">
      <div class="required field">
        <label>Reason for Declining</label>
        <input
          [(ngModel)]="reason"
          type="text"
          placeholder="Enter company registration number"
        />
      </div>
    </div>
    <div class="content">
      <div class="ui basic center aligned segment">
        <p>{{ modal.context.question }}</p>
        <div class="inline">
          <button
            class="ui  basic primary button"
            (click)="modal.deny(undefined)"
          >
            No
          </button>
          <button
            class="ui  primary button"
            [disabled]="!reason"
            (click)="modal.approve(reason)"
            autofocus
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./confirm-modal.component.scss'],
})
export class RejectModalComponent implements OnInit, OnDestroy {
  reason;
  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IRejectModalContext, void, void>
  ) {}
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}

export class RejectModal extends ComponentModalConfig<
  IRejectModalContext,
  void,
  void
> {
  constructor(
    title: string,
    question: string,
    size: ModalSize = ModalSize.Small
  ) {
    super(RejectModalComponent, { title, question });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
